import * as actionTypes from "../Actions/SandBoxAuthenticationActionTypes";
import LogService from "../../CommonSdk/LogService";

const LOG_TAG = "REDUCER:SANDBOX_AUTHENTICATION";

const initialState = {
    account: {
        environment: [],
        authentication: [],
        baseServerUrl: "",
        selectedServerIndex: 0,
        selectedLoginIndex: 0,
        token: ""
    }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.SANDBOX_AUTHENTICATION_ENVIRONMENT_SET_BASE_SERVER:
            LogService.trace(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    baseServerUrl: action.payload.baseServerUrl
                }
            };

        case actionTypes.SANDBOX_AUTHENTICATION_ENVIRONMENT_CLEAR_BASE_SERVER:
            LogService.trace(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    baseServerUrl: ""
                }
            };

        case actionTypes.SANDBOX_AUTHENTICATION_ENVIRONMENT_SELECT:
            LogService.trace(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    selectedServerIndex: action.payload.selectedServerIndex
                }
            };
        case actionTypes.SANDBOX_AUTHENTICATION_ENVIRONMENT_SUCCESS:
            LogService.trace(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    environment: action.payload.environment,
                    selectedServerIndex: 0
                }
            };
        case actionTypes.SANDBOX_AUTHENTICATION_ENVIRONMENT_CLEAR:
            LogService.trace(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    environment: [],
                    selectedServerIndex: 0
                }
            };
        case actionTypes.SANDBOX_AUTHENTICATION_SELECT:
            LogService.trace(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    selectedLoginIndex: action.payload.selectedLoginIndex
                }
            };
        case actionTypes.SANDBOX_AUTHENTICATION_SUCCESS:
            LogService.trace(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    authentication: action.payload.authentication,
                    selectedLoginIndex: 0
                }
            };
        case actionTypes.SANDBOX_AUTHENTICATION_CLEAR:
            LogService.trace(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    authentication: [],
                    selectedLoginIndex: 0
                }
            };
        case actionTypes.SANDBOX_AUTHENTICATION_LOGGED_IN:
            LogService.info(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...state.account,
                    token: action.payload.token
                }
            };
        case actionTypes.SANDBOX_AUTHENTICATION_LOGGED_OUT:
            LogService.info(LOG_TAG, "reduce", action.type);
            return {
                account: {
                    ...initialState.account,
                    baseServerUrl: state.account.baseServerUrl
                }
            };

        default:
            return state;
    }
}
